<template>
  <!-- <div v-if="Seleccionado">
    <Cartilla :id_plan="Seleccionado.id_plan"></Cartilla>
  </div> -->
  <Cartilla />
</template>

<script>
// import { mapActions, mapState } from "vuex";
import Cartilla from "@/components/Efectores/Cartilla";
// import API from "../../../lib/API";
// import LUM from "../../../lib/LUM";
export default {
  data() {
    return {
      valida: true,
    };
  },
  components: {
    Cartilla,
  },
  // computed: {
  //   ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
  //   ...mapState("autogestion", ["Usuario"]),
  //   logueado() {
  //     return this.Seleccionado !== undefined && this.Seleccionado !== null;
  //   },
  //   localidad: {
  //     get: function() {
  //       return {
  //         id_localidad: this.Seleccionado.id_localidad,
  //         codigo_postal: this.Seleccionado.codigo_postal,
  //         id_provincia: this.Seleccionado.id_provincia,
  //       };
  //     },
  //     set: function(newValue) {
  //       this.Seleccionado.id_localidad = newValue.id_localidad;
  //       this.Seleccionado.id_provincia = newValue.id_provincia;
  //     },
  //   },
  //   observaciones() {
  //     this.valida = true;
  //     let obs = "";
  //     if (this.Seleccionado.mail == "") {
  //       obs += " * ingrese un mail";
  //     }
  //     if (!LUM.validateEmail(this.Seleccionado.mail)) {
  //       obs += " * email incorrecto";
  //     }
  //     if (this.Seleccionado.telefono.trim().length != 10) {
  //       obs += " * Telefono incorrecto";
  //     }
  //     if (this.Seleccionado.domicilio.trim().length == 0) {
  //       obs += " * Ingrese el domicilio";
  //     }

  //     if (isNaN(this.Seleccionado.codigo_postal)) {
  //       obs += " * Codigo postal debe ser numerico";
  //     }
  //     if (
  //       this.Seleccionado.codigo_postal < 1000 ||
  //       this.Seleccionado.codigo_postal > 9999
  //     ) {
  //       obs += " * Codigo postal incorrecto ";
  //     }
  //     if (obs) {
  //       this.valida = false;
  //     }

  //     return obs;
  //   },
  // },
  // methods: {
  //   ...mapActions("autogestion", ["inicializar"]),
  //   ...mapActions("beneficiarios", ["select"]),
  // },
  // async mounted() {
  //   if (!this.Usuario) {
  //     await this.inicializar();
  //     if (!this.Usuario) {
  //       this.$router.push({ name: "Autogestion" });
  //     }
  //   }
  //   if (this.Usuario && this.Seleccionado == undefined) {
  //     let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId);
  //     this.select(ben);
  //   }
  // },
};
</script>

<style></style>
